<template>
    <div>
        <header class="auth-layout__header">
            <router-link :to="{ name: RoutesEnum.INDEX.HOME }" class="auth-layout__logo">
                <common-icon name="logo" size="extra-large"></common-icon>
            </router-link>
        </header>

        <common-page-header :heading="$t('pages.auth.login.activating')" size="large" :isCenter="true"></common-page-header>
    </div>
</template>

<script>
    import AuthAPI from 'api/AuthAPI'
    import RoutesEnum from 'enums/routes.enum'

    export default {
        data: () => ({ RoutesEnum }),

        mounted() {
            this.$startLoader()
            const token = this.$route.query?.token

            AuthAPI.confirmEmailChange({ token })
                .then(() => this.$router.push({ name: RoutesEnum.AUTH.LOGIN, query: { text: 'success', type: 'success' } }))
                .catch(() => this.$router.push({ name: RoutesEnum.AUTH.LOGIN, query: { text: 'error', type: 'error' } }))
                .finally(() => this.$stopLoader())
        },
    }
</script>
